import React,{useContext} from 'react';
import firebase from "firebase/app";
import "firebase/auth";
import firebaseConfig from './firebase.config';
import { UserContext } from '../../App';
import { useHistory, useLocation } from 'react-router';



const Login = () => {
  const [loggedInUser,setLoggedInUser]= useContext(UserContext);
const history= useHistory();
const location =useLocation();
const { from } = location.state || { from: { pathname: "/" } };

    !firebase.apps.length && firebase.initializeApp(firebaseConfig);
    const handleSignIn=() =>{
        var provider = new firebase.auth.GoogleAuthProvider();
        firebase.auth()
  .signInWithPopup(provider)
  .then((result) => {
    const {displayName,email} = result.user;
    const signedInUser={name:displayName,email}
    setLoggedInUser(signedInUser);
    history.replace(from);
    // ...
   
  }).catch((error) => {
    var errorCode = error.code;
    var errorMessage = error.message;
    var email = error.email;
    var credential = error.credential;
    console.log(errorCode,errorMessage,email,credential)

    // ...
  });


    }
    return (
       
      <div className="row align-items-center resume mr-2 p-3" >
      
          <div className="">
            <button className="btn btn-light" onClick={handleSignIn}>Continue With Google</button>
          </div>
      </div>
    
    );
};

export default Login; 